import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Layout from "../components/layout";
import { Landing, Footer, News } from '../components';
import SEO from "../components/seo";

const IndexPage = (props) => {
  return (
    <StaticQuery
      query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "Holsum-60-anos.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
      render={data =>
        <Layout>
          <SEO title="Home" keywords={[`bread`, `application`, `react`, `bakery`, `puerto rico`]} />
          <Landing />
          <News />
          <Footer />
        </Layout>
      }
    />
  )
}

export default IndexPage
